<div class="blank-layout-container justify-content-center">
  <div class="position-relative row w-100 h-100">
    <div class="col-lg-7 col-xl-8 bg-gredient p-0">
      <div class="p-24 h-100">
        <div
          class="align-items-center justify-content-center img-height d-none d-lg-flex"
        >
          <img
            src="/assets/images/logos/dark-logo.png"
            alt="login"
            style="max-width: 500px"
          />
        </div>
      </div>
    </div>
    <div class="col-lg-5 col-xl-4 p-0">
      <div
        class="d-flex align-items-start align-items-lg-center justify-content-center h-100"
      >
        <div class="row justify-content-center w-100">
          <div class="col-lg-9 max-width-form">
            <h4 class="f-w-700 f-s-24 m-0">Bienvenido a INGE</h4>
            <span class="f-s-14 d-block mat-body-1 m-t-8"
              >Portal de Garantias</span
            >

            <h3 class="d-block f-w-500 d-block m-t-24">Cambia tu Contraseña</h3>
            <form class="m-t-30" [formGroup]="formPass" (ngSubmit)="submit()">
              <mat-form-field
                appearance="outline"
                class="w-100"
                color="primary"
              >
                <mat-label>Contraseña</mat-label>
                <input
                  matInput
                  [type]="hide ? 'password' : 'text'"
                  formControlName="password"
                />

                <div
                  *ngIf="f['password'].touched && f['password'].invalid"
                  class="error-msg-pass"
                >
                  <div
                    class="text-error"
                    *ngIf="
                      f['password'].errors && f['password'].errors['required']
                    "
                  >
                    Este Campo es requerido
                  </div>
                  <div
                    class="text-error"
                    *ngIf="
                      f['password'].errors && f['password'].errors['minlength']
                    "
                  >
                    Debe tener un minimo de 8 caracteres
                  </div>
                  <div
                    class="text-error"
                    *ngIf="
                      f['password'].errors && f['password'].hasError('pattern')
                    "
                  >
                    El formato de la contraseña no es válido. Debe contener al
                    menos una mayúscula, una minúscula, un número y un carácter
                    especial.
                  </div>
                </div>

                <span
                  style="
                    border: 0px;
                    background: transparent;
                    cursor: pointer;
                    padding-right: 5px;
                  "
                  matSuffix
                  (click)="hide = !hide"
                  [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hide"
                >
                  <mat-icon>{{
                    hide ? "visibility_off" : "visibility"
                  }}</mat-icon>
                </span>
              </mat-form-field>

              <mat-form-field
                appearance="outline"
                class="w-100"
                color="primary"
              >
                <mat-label>Repita Contraseña</mat-label>
                <input
                  matInput
                  [type]="hide ? 'password' : 'text'"
                  formControlName="confirmPassword"
                />
                <span
                  style="
                    border: 0px;
                    background: transparent;
                    cursor: pointer;
                    padding-right: 5px;
                  "
                  matSuffix
                  (click)="hide = !hide"
                  [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hide"
                >
                  <mat-icon>{{
                    hide ? "visibility_off" : "visibility"
                  }}</mat-icon>
                </span>
                <div
                  *ngIf="
                    f['confirmPassword'].touched && f['confirmPassword'].invalid
                  "
                  class="error-msg-pass"
                >
                  <div
                    class="text-error"
                    *ngIf="
                      f['confirmPassword'].errors &&
                      f['confirmPassword'].errors['required']
                    "
                  >
                    Este Campo es requerido
                  </div>
                  <div
                    class="text-error"
                    *ngIf="
                      f['confirmPassword'].errors &&
                      f['confirmPassword'].errors['minlength']
                    "
                  >
                    Debe tener un minimo de 8 caracteres
                  </div>
                  <div
                    class="text-error"
                    *ngIf="
                      f['confirmPassword'].errors &&
                      f['confirmPassword'].hasError('pattern')
                    "
                  >
                    El formato de la contraseña no es válido. Debe contener al
                    menos una mayúscula, una minúscula, un número y un carácter
                    especial.
                  </div>
                </div>
              </mat-form-field>

              <mat-action-row>
                <button
                  mat-flat-button
                  color="primary"
                  class="w-100"
                  [disabled]="!formPass.valid"
                >
                  Ingresar
                </button>
              </mat-action-row>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
